import {Action, ActionReducer, ActionReducerMap, createFeatureSelector, MetaReducer} from '@ngrx/store';
import {routerReducer, RouterReducerState} from '@ngrx/router-store';

import {authReducer} from './auth/auth.reducer';
import {RouterStateUrl} from '../router/router.state';
import {authLogout} from './auth/auth.actions';
import {AuthState} from './states/auth-state';

/* Si se quiere debugear el redux, se agrega esta funcion al meta reducer
export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action)  => {
    return reducer(state, action);
  };
}*/

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state: any, action: Action) => {
    if (action.type === authLogout.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  router: routerReducer
};

/** Esto es para guarda algnos elementos de los estado en el local storage
 * ver ejemplo de implementacion en
 * https://medium.com/bb-tutorials-and-thoughts/retaining-state-of-the-angular-app-when-page-refresh-with-ngrx-6c486d3012a9
 */
export const metaReducers: MetaReducer<AppState>[] = [clearState, /*initStateFromLocalStorage*/];
export const selectAuthState = createFeatureSelector<AppState, AuthState>('auth');
export const selectRouterState = createFeatureSelector<AppState, RouterReducerState<RouterStateUrl>>('router');

export interface AppState {
  auth: AuthState;
  router: RouterReducerState<RouterStateUrl>;
}
